import {Injectable, Inject} from 'ng-metadata/core';
import {AccountService} from '../account.service';
import {MappingTablesCache} from '../../mappingTablesCache/mappingTablesCache.service';
import {LinkedUserSelectorService}from '../linkedUserSelector/linkedUserSelector.service';
import { getInjectableName} from 'ng-metadata/core';
import {ConfigurationUtil} from '../../nddUtils/configurationUtil.service';

const orderBy= require('lodash/orderBy');
const intersection= require('lodash/intersection');


@Injectable()
export class AccountOverviewService {

    private _finesCounter : string;
    private _demeritsCounter : string;
    private _loansCounter : number;
    private _historyLoansCounter : number;
    private _requestsCounter : number;
    private _depositsCounter : number;
    private _requiredTabsList: [Object];

    constructor(private accountService: AccountService, private linkedUserSelectorService:LinkedUserSelectorService,
                private mappingTablesCache: MappingTablesCache, private configurationUtil : ConfigurationUtil){
        this.setRequiredTabsList();
    }

    private setRequiredTabsList(){
        let hardcodedOrder = this.getHardcodedOrder();
        let requiredTabsList= this.mappingTablesCache.getTable('My Account Menu Configuration - OvP');
        requiredTabsList.forEach((config)=>{config.source2= config.source2.replace('myaccount','')});
        requiredTabsList=  orderBy(requiredTabsList,(val)=>parseInt(val['source2']), 'desc');
        requiredTabsList= requiredTabsList.filter((config)=>config.target==='Yes');
        requiredTabsList= requiredTabsList.map((config)=>config.source3);
        this._requiredTabsList= intersection(hardcodedOrder, requiredTabsList);
    }

    getHardcodedOrder() {
        if(this.isRapidoSAEnabled()){
            return ["personal_settings","requests"];
        }
        return ["deposits", "personal_settings", "blocks", "fines", "requests", "loans"]; //TODO: should be changed so that order is also from configuration
    }

    isRapidoSAEnabled(){
        return this.configurationUtil.getRapidoSAEnabled()
    }

    get requiredTabsList(){
        return this._requiredTabsList;
    }

    updateCounters(){
        this.accountService.makeIlsRequest('counters', null)
            .then((response)=>this.setCounters(response));
    }

    private setCounters(response){
        try{
			let countersMap = {};
			let counters = response.data.listofactions.action;
			counters.forEach((counter) => {
				countersMap[counter.type] = counter.value;
			});
            this._finesCounter= countersMap['Fines']? countersMap['Fines'] : '0';
            this._demeritsCounter= countersMap['Demerits']? countersMap['Demerits'] : '0';
            this._loansCounter= countersMap['Loans']? parseInt(countersMap['Loans']) : 0;
            this._historyLoansCounter= countersMap['HistoryLoans']? parseInt(countersMap['HistoryLoans']) : 0;
            this._requestsCounter= countersMap['Requests']? parseInt(countersMap['Requests']) : 0;
            this._depositsCounter= countersMap['Deposits']? parseInt(countersMap['Deposits']) : 0;
            this.linkedUserSelectorService.setInstitutionsList(response);
        }
        catch(err){
        }
    }

    get finesCounters(){
        if (!parseFloat(this._finesCounter)){
            return 0; //if the string parses as 0 we want to return a number equivalent of false
        }
        return this._finesCounter;
    }

    get demeritsCounter(){
        if (!parseFloat(this._demeritsCounter)){
            return 0; //if the string parses as 0 we want to return a number equivalent of false
        }
        return this._demeritsCounter;
    }

    get loansCounters(){
        return this._loansCounter;
    }
    
    get historyLoansCounters(){
        return this._historyLoansCounter;
    }

    get requestsCounter(){
        return this._requestsCounter;
    }

    get depositsCounter(){
        return this._depositsCounter;
    }
}
//put here all angular1 modules the service is using
    export
    default
    [];



// WEBPACK FOOTER //
// ./src/main/webapp/components/account/overview/accountOverview.service.ts